export const getLeadStages = `
  query getLeadStage {
    leadAttributeOptions: leadStages {
      value: leadStageUuid
      label: name
    }
  }
`;

export const getLeadSources = `
  query getLeadSource {
    leadAttributeOptions: leadSources {
      value: leadSourceUuid
      label: name
    }
  }
`;
